import { httpClient } from '@/infra/protocols/http';
import { IMusicDTO } from '@/modules/musics/dto/music.dto';
import { IMusic } from '@/modules/musics/entities/music.entity';
import { MusicMapper } from '@/modules/musics/mappers/music.mapper';

export async function getMusics(): Promise<CreateMusicService.Response> {
  const response = await httpClient.get<IMusicDTO[]>(`/v1/musicas`);
  return response.map(MusicMapper.toPresentation);
}

export namespace CreateMusicService {
  export type Response = IMusic[];
}
